// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"24":"812c27a9","479":"7fc80475","655":"97853116","869":"58a3f085"}[chunkId] + ".chunk.js";
};